module.exports = __webpack_public_path__ + "img/delete-default.6151ac13.svg";